import * as bootstrap from 'bootstrap'

document.addEventListener("DOMContentLoaded", function(event) {
    //Modals of the just unlocked achievements
    const modals = document.querySelectorAll('.modal.achievement[data-auto-open]');

    if (modals) {
        modals.forEach(modal => {
            //Generate modal object
            const myModal = new bootstrap.Modal(modal, {
                keyboard: false
            })

            //Open modal
            myModal.toggle();

            //Dismiss achievement
            modal.addEventListener('hidden.bs.modal', event => {
                // Set the achievement as seen
            })
        });
    }

    //Owned achievements cards (achievements page): open the modal also with the keyboard
    document.querySelectorAll('.achievement.list .card[data-bs-toggle="modal"]').forEach(card => {
        card.addEventListener('keydown', (e) => {
            if (e.target === card && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                bootstrap.Modal.getOrCreateInstance(document.querySelector(card.dataset.bsTarget)).show();
            }
        });
    });
});
